(function() {
	'use strict';
	angular.module('quantixApp').controller('RatingDetailsController1',
			RatingDetailsController1);
	RatingDetailsController1.$inject = [ '$scope', 'GenericService',
			'Principal', '$state', '$http', '$sce', 'PortfolioService',
			'$window', '$location', 'GenericServiceNew', 'AlertService',
			'$uibModal', 'ErrorHandlerService', '$stateParams', '$timeout',
			'baseRequest' ];

	function RatingDetailsController1($scope, GenericService, Principal,
			$state, $http, $sce, PortfolioService, $window, $location,
			GenericServiceNew, AlertService, $uibModal, ErrorHandlerService,
			$stateParams, $timeout, baseRequest) {
		var instrumentDetailsGrid = '';

		if ($window.localStorage.portfolioIdToRedirect) {
			$stateParams = JSON
					.parse($window.localStorage.portfolioIdToRedirect);
			$window.localStorage.removeItem('portfolioIdToRedirect');
		}

		$scope.portfolioId = $stateParams.portfolioId;
		$scope.portfolioType = $stateParams.portfolioType;
		$scope.portfolioDateTime = $stateParams.portfolioDateTime;

		// console.log(paramsValue);

		if ($stateParams.asOnDate != undefined) {
			var firstDay = '01 ' + $stateParams.asOnDate;
			var epochSeconds = Date.parse(firstDay);
			var t = new Date(epochSeconds);
			$scope.asOnDate = new Date(t.getFullYear(), t.getMonth() + 1, 0,
					23, 59, 59)
		} else {
			$scope.asOnDate = new Date();

		}

		if ($stateParams.portfolioId == null
				|| !angular.isDefined($stateParams.portfolioId)) {
			$state.go('portfolioDashboard')
		}
		$scope.selectedPortName = $stateParams.portfolioName;

		$scope.removeAlert = false;
		var vm = this;

		$scope.showFinanceBtn = true;
		$scope.showRatingBtn = true;

		$scope.currentbstId = $stateParams.currentbstId;
		$scope.portfolioRatingDetailsList = [];
		$scope.instrumentDetailsList = [];
		vm.selectedAgencies = [];
		vm.selectedAgenciesForIns = [];
		$scope.ratingAgencyData = [];
		vm.selectedActions = [];
		vm.selectedScalesShortTerm = [];
		vm.selectedActions1 = [];
		vm.selectedScalesShortTerm1 = [];
		$scope.ratingActionData = [];
		// get filter list of compnaies
		$scope.companyCode = "";
		var portfoloioListGrid = '';

		// for filter on rating constituents /portfolio list
		$scope.ratingingConstituentsDeatilsFilter = '';
		// for filter on rating Instrumental portfolio list
		$scope.ratingingInstrumentDetailsFilter = '';
		$scope.errorViewRatingDetails = false;
		$scope.errorViewInstrumentDetails = false;
		var sectionaccess = {};
		GenericService.getUserModuleAccessData().then(function(result) {
			$scope.userModuleAccessData = result;
		});

		$scope.ratingDetailsNewTab = {
			"ratingDetailsId" : {
				"detailsType" : "ratingdetails",
				"detailsLabel" : "Rating Details",
				"currentbstId" : "1"
			},
			"instrumentDetailsId" : {
				"detailsType" : "instrumentdetails",
				"detailsLabel" : "Instrument Details",
				"currentbstId" : "2"
			},

		}
		$scope.details = {
			"detailsType" : 'ratingdetails'
		};

		// $scope.userDetailsModel = '';
		// $scope.details.detailsType='';
		
		if($stateParams.ratingInstruList==undefined && $scope.currentbstId == 1){
			$scope.ratingList = 'stdPortfolioDetails';
			$scope.userDetailsModel='stdPortfolioDetails'
		}else if ($scope.currentbstId == 1 && $stateParams.ratingInstruList!=undefined) {
			$scope.details.detailsType = 'ratingdetails';
			$scope.userDetailsModel = $stateParams.ratingInstruList;
		} else if($stateParams.ratingInstruList!=undefined && $scope.currentbstId == 2){
			$scope.details.detailsType = 'instrumentdetails';
			$scope.instrumentStModel = $stateParams.ratingInstruList;
		}else if($stateParams.ratingInstruList==undefined && $scope.currentbstId == 2){
			$scope.details.detailsType = 'instrumentdetails';
			$scope.instrumentStModel = 'stdinstrumentPortfolioDetails';
		}

		$scope.isActiveTabForNewTab = function(selectedTabForDetails) {
			return selectedTabForDetails === $scope.details.detailsType;
		}

		// $scope.flagForRatingDetails = 'stdPortfolioDetails';
		$scope.getUpdatesForNewTab = function(value) {

			console.log($scope.currentbstId);
			console.log($scope.flagForRatingDetails);
			console.log("method called");

			if (value != undefined) {

				$scope.currentbstId = value.currentbstId;
				$scope.details.detailsType = value.detailsType;
			} else {
				$scope.currentbstId = 1;
				$scope.details.detailsType = "ratingdetails"
			}

			if ($scope.details.detailsType == "ratingdetails") {
				$scope.userDetailsModel = 'stdPortfolioDetails';
				$scope.getPortfolioListFilterData();
			} else {
				$scope.instrumentStModel = 'stdinstrumentPortfolioDetails';
				$scope.getInstrumentDetailsFilterData();
			}

		}

		GenericService
				.getUserSectionAccessData()
				.then(
						function(result) {
							sectionaccess = result;
							if (sectionaccess['Portfolio View.Rating Details'] != 'Y'
									&& sectionaccess['Portfolio View.Instrument Details'] != 'Y') {

								ErrorHandlerService
										.forbiddenErrorForDetailForPortFolio(
												"Rating Details",
												$scope.portfolioId,
												$scope.selectedPortName,
												$scope.portfolioType,
												$scope.portfolioDateTime);
								return;
							}

							if (sectionaccess['Portfolio View.Rating Details'] != 'Y') {
								$scope.errorViewRatingDetails = true;
								$scope.errorViewRatingDetailsMessage = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";

							}
							if (sectionaccess['Portfolio View.Instrument Details'] != 'Y') {
								$scope.errorViewInstrumentDetails = true;
								$scope.errorViewInstrumentDetailsMessage = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";

							}
						});

		// Calender
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];

		vm.singleDate = $scope.asOnDate;

		$scope.startMaxDate = new Date();
		$scope.popup3 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;

		};
		$scope.singleDate = false;
		$scope.showData = false;
		/*
		 * $scope.duration = function(durationData) { console.log(durationData)
		 * if (durationData == 'option1') { $scope.showData = true;
		 * $scope.singleDate = false; $scope.singleDateData = '';
		 * $scope.selectedDuration=''; $scope.selectedDurationTemp =''; } else
		 * if(durationData == 'singleDate'){ vm.fromDate=""; vm.toDate="";
		 * $scope.singleDate = true; $scope.showData = false;
		 * $scope.selectedDuration=''; $scope.selectedDurationTemp ='';
		 * 
		 * }else if (durationData != 'option1') { vm.fromDate=""; vm.toDate="";
		 * $scope.selectedDurationTemp = durationData; $scope.singleDateData =
		 * ''; $scope.singleDate = false; $scope.showData = false; } }
		 */

		// get filter list of compnaies
		$scope.searchFilterForCompanyProfile = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a compnay
			$scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings, "PORTFOLIO")
						.then(
								function(data) {

									$scope.companies = data;

									if ($scope.companies.length == 0) {
										AlertService
												.error("Please search the appropriate company!");
									}
								},
								function(errordata) {
									AlertService
											.error("Error while searching company!");
								});
			}

		}
		// select company from filtered list
		$scope.selectCompany = function(companyObj) {
			$scope.companyCode = companyObj.companyCode;
			$scope.companyName = companyObj.companyName;
			$scope.companyFlag = companyObj.companyFlag;
		}
		$scope.getBackToPortfolioDetails = function() {
			$state.go('portfolioLanding', {
				'portfolioId' : $scope.portfolioId,
				'portfolioName' : $scope.selectedPortName,
				'portfolioType' : $scope.portfolioType,
				'portfolioDateTime' : $scope.portfolioDateTime
			});
		}
		$scope.getRatingAgencies = function() {

			if ($scope.ratingAgencyData.length == 0) {

				PortfolioService.getRatingAgencyMasterList().then(
						function(data) {

							var newData = data.filter(function(el) {
								return el.name !== 'All Rating Agencies';
							});

							$scope.ratingAgencyData = newData;

						}, function(error) {
						});
			}

		}
		$scope.getRatingActions = function() {
			// alert(selectedActions);
			if ($scope.ratingActionData.length == 0) {

				PortfolioService.getRatingActionMasterList().then(

				function(data) {
					$scope.ratingActionData = data;
				}, function(error) {
				});
			}
		}

		Array.prototype.groupBy = function(prop) {
			return this.reduce(function(groups, item) {
				var val = item[prop];
				groups[val] = groups[val] || [];
				groups[val].push(item);
				return groups;
			}, {});
		}

		$scope.getRatingScales = function() {
			$scope.mergeArray = [];

			PortfolioService.getRatingScaleMasterData().then(function(data) {

				var arr = [];
				var ratingtypeobj = data.groupBy('type');
				var ratetype = [];
				for ( var key in ratingtypeobj) {
					var obj = {
						'name' : key,
						'msGroup' : true
					};
					ratetype.push(obj);
					ratingtypeobj[key].map(function(row) {
						ratetype.push(row);
					});
					var objf = {

						'msGroup' : false
					};
					ratetype.push(objf);
				}
				$scope.mergeArray = ratetype;
			}, function(error) {
			});

		}

		// disable othere rating type if
		// Issuer Rating is selected in multiselct controle
		$scope.disableOtherType = function(compo, isReset) {
			// filter selected Issuer rating into array
			var issuerRatingList = [];
			if (!isReset) {
				issuerRatingList = compo.filter(function(el) {
					return typeof el.symbol !== 'undefined'
							&& el.symbol.indexOf('IR ') > -1 && el.ticked;
				});
			}
			if (issuerRatingList.length > 0) {
				$.each(compo, function(key, value) {
					if (typeof value.symbol !== 'undefined'
							&& !(value.name == 'Issuer Rating' || value.symbol
									.indexOf('IR ') > -1)) {
						value.disabled = true;
						value.ticked = false;
					}
				});
			} else {
				$.each(compo, function(key, value) {
					value.disabled = false;
				});
			}
		}

		$scope.getRatingAgencies();
		$scope.getRatingActions();
		$scope.getRatingScales();

		/*
		 * $scope.setTabSetData = function(tabsetId) { if (tabsetId == 1) {
		 * $scope.userDetailsModel = 'stdPortfolioDetails';
		 * $scope.resetFilter(); } if (tabsetId == 2) { $scope.instrumentStModel =
		 * 'stdinstrumentPortfolioDetails';
		 * 
		 * if ($stateParams.portfolioId != null ||
		 * angular.isDefined($stateParams.portfolioId)) {
		 * $scope.resetInstrumentsFlt(); } }
		 * 
		 * $scope.currentbstId = tabsetId; }
		 */

		$scope.getPortfolioListFilterData = function() {
			
			$scope.showFinanceBtn = true;
			$scope.showRatingBtn = true;
			$scope.selectedScalesShortTermTemp = [];
			$scope.selectedActionsTemp = [];
			var ratingType = [];
			$scope.ratingTypeValue = [];
			if (vm.selectedScalesShortTerm != undefined
					&& vm.selectedScalesShortTerm.length > 0) {
				$scope.selectedScalesShortTermTemp = vm.selectedScalesShortTerm
						.map(function(element) {

							if (ratingType.filter(function(x) {
								return x === element.type;
							}).length == 0) {
								ratingType.push(element.type);
							}
							return "<" + String(element.name) + "<";
						})

				$scope.ratingTypeValue = ratingType.map(function(element) {
					return "<" + String(element) + "<";
				})

			}

			if (vm.selectedActions != undefined
					&& vm.selectedActions.length > 0) {

				$scope.selectedActionsTemp = vm.selectedActions.map(function(
						element) {
					return "<" + String(element.name) + "<"
				})
			}

			if (vm.searchCompanies == undefined)
				vm.searchCompanies = ' ';
			if (vm.outlook == undefined)
				vm.outlook = '';

			$scope.flagForRatingDetails = '';
			if ($scope.userDetailsModel == 'suspendedGr15') {
				$scope.flagForRatingDetails = $scope.userDetailsModel;
				$scope.ratingList = 'SuspendedPortfolioDetails';
			} else if ($scope.userDetailsModel == 'userPortfolioDetails') {
				$scope.ratingList = 'userPortfolioDetails';
			} else if ($scope.userDetailsModel == 'stdPortfolioDetails') {
				$scope.ratingList = 'stdPortfolioDetails';
			}

			var inputs = "{'agency' : '" + vm.selectedAgencies
					+ "', 'ratingAction' : '" + $scope.selectedActionsTemp
					+ "', 'ratingType' : '" + $scope.ratingTypeValue
					+ "', 'outStandingRating' : '"
					+ $scope.selectedScalesShortTermTemp
					+ "', 'nameOfCompany' : '" + vm.searchCompanies
					+ "', 'condition' : '" + $scope.userDetailsModel
					+ "','outlook' : '" + vm.outlook + "','portfolioId':' "
					+ $scope.portfolioId + "','asOnDate':'" + vm.singleDate
					+ "','flagForRatD' : '" + $scope.flagForRatingDetails
					+ "'}";
			inputs = inputs.replace(/\'/g, "\"");
			inputs = inputs.replace(/\</g, "\'");
			$scope.inputDataTemp = inputs;
			PortfolioService
					.getPortfolioList(inputs)
					.then(
							function(result) {

								$scope.portfolioRatingDetailsList = result.finalConstituentsList[1];
								$scope.portfolioRatingDetailsCompanyCount = result.finalConstituentsList[2];
								$scope.totalcount = result.finalConstituentsList[3];
								$scope.userId = result.userDoc[0];
								$scope.portfoloioListGridData = {
									dataProvider : $scope.portfolioRatingDetailsList,
									delegate : $scope
								}

								$scope.ratingingConstituentsDeatilsFilter = inputs;
								$timeout(function() {
									$scope.portfoloioListGridDataInit();
								}, 100);
							}, function(error) {

							});

		}

		$scope.resetFilter = function() {
			$scope.addPrevRatingColumn = false;
			$scope.addFinancialColumn = false;
			vm.selectedAgencies = [];
			vm.singleDate = $scope.asOnDate;
			// $scope.ratingAgencyData = [];
			vm.selectedActions = [];
			vm.selectedScalesShortTerm = [];
			// $scope.ratingActionData = [];
			vm.searchCompanies = ' ';
			vm.outlook = '';
			$scope.ratingingConstituentsDeatilsFilter = '{"agency": "", "ratingAction": "", "outStandingRating": "", "nameOfCompany": "", "outlook": "","asOnDate": "" }';
			$scope.getRatingScales();
			$scope.getPortfolioListFilterData();
		}

		// $scope.ratingList = 'stdPortfolioDetails';
		// $scope.instrumentRatingList = 'stdinstrumentPortfolioDetails';
		$scope.getPortfolioList = function() {
			$scope.erroruserUpdatedDetails = false;
			$scope.uniqueCompanyName = [];
			$scope.addPrevRatingColumn = false;
			$scope.addFinancialColumn = false;
			$scope.ratingList = "stdPortfolioDetails";
			$scope.portfoloioListGridData = {
				dataProvider : $scope.portfolioRatingDetailsList,
				delegate : $scope
			}
			$.each($scope.portfolioRatingDetailsList, function(i, el) {
				if ($.inArray(el.companyCode, $scope.uniqueCompanyName) === -1)
					$scope.uniqueCompanyName.push(el.companyCode);
			});
			$scope.portfolioRatingDetailsCompanyCount = $scope.uniqueCompanyName.length;
			$timeout(function() {
				$scope.portfoloioListGridDataInit();
			}, 100);
		}
		$scope.erroruserUpdatedDetails = false;
		$scope.getUserPortfolioList = function() {

			$scope.ratingList = "userPortfolioDetails";

			if (sectionaccess['Portfolio View.User Updated Details'] != 'Y') {
				$scope.erroruserUpdatedDetails = true;
				$scope.errorMsguserUpdatedDetails = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";

			} else {
				$scope.finalPortfolioRatingDetailsList = $scope.portfolioRatingDetailsList;
				$scope.uniqueCompanyName = [];
				$scope.addPrevRatingColumn = false;
				$scope.addFinancialColumn = false;

				$scope.portfoloioListGridData = {
					dataProvider : $scope.finalPortfolioRatingDetailsList,
					delegate : $scope
				}
				$.each($scope.finalPortfolioRatingDetailsList,
						function(i, el) {
							if ($.inArray(el.companyCode,
									$scope.uniqueCompanyName) === -1)
								$scope.uniqueCompanyName.push(el.companyCode);
						});
				$scope.portfolioRatingDetailsCompanyCount = $scope.uniqueCompanyName.length;
				$timeout(function() {
					$scope.portfoloioListGridDataInit();
				}, 100);
			}
		}
		$scope.getSusGr15 = function() {
			// console.log($scope.userDetailsModel);
			$scope.erroruserUpdatedDetails = false;
			$scope.ratingList = 'SuspendedPortfolioDetails';
			$scope.addPrevRatingColumn = false;
			$scope.addFinancialColumn = false;
			$scope.uniqueCompanyName = [];
			// $scope.ratingList = "stdPortfolioDetails";
			$scope.susArr = [];
			angular
					.forEach(
							$scope.portfolioRatingDetailsList,
							function(value) {
								var difference = (new Date().getFullYear() * 12 + new Date()
										.getMonth())
										- (new Date(value.lastRatingAction)
												.getFullYear() * 12 + new Date(
												value.lastRatingAction)
												.getMonth());
								if (value.ratingAction == 'Suspended'
										|| difference + 1 > 15
										|| value.outStandingRating
												.indexOf('(Issuer Non Co-operative)') >= 0) {
									$scope.susArr.push(value);

								}
							});

			$.each($scope.susArr, function(i, el) {
				if ($.inArray(el.companyCode, $scope.uniqueCompanyName) === -1)
					$scope.uniqueCompanyName.push(el.companyCode);
			});
			$scope.portfolioRatingDetailsCompanyCount = $scope.uniqueCompanyName.length;
			$scope.portfoloioListGridData = {
				dataProvider : $scope.susArr,
				delegate : $scope
			}
			$timeout(function() {
				$scope.portfoloioListGridDataInit();
			}, 100);

		}
		$scope.getSusGr15ForIns = function() {
			$scope.uniqueCompanyNameIns = [];

			$scope.susArrIns = [];
			angular
					.forEach(
							$scope.instrumentDetailsList,
							function(value) {
								var difference = (new Date().getFullYear() * 12 + new Date()
										.getMonth())
										- (new Date(value.lastRatingAction)
												.getFullYear() * 12 + new Date(
												value.lastRatingAction)
												.getMonth());
								if (value.ratingAction == 'Suspended'
										|| difference + 1 > 15
										|| value.outStandingRating
												.indexOf('(Issuer Non Co-operative)') >= 0)
									$scope.susArrIns.push(value);
							});
			$.each($scope.susArrIns,
					function(i, el) {
						if ($.inArray(el.companyCode,
								$scope.uniqueCompanyNameIns) === -1)
							$scope.uniqueCompanyNameIns.push(el.companyCode);
					});
			$scope.portfolioRatingDetailsInsCompanyCount = $scope.uniqueCompanyNameIns.length;
			$scope.instrumentDetailsGridData = {
				dataProvider : $scope.susArrIns,
				delegate : $scope
			}
			$timeout(function() {
				$scope.instrumentDetailsGridDataInit();
			}, 100);

		}
		$scope.instrumentUserModel = false;
		$scope.erroruserUpdatedDetailsIns = false;
		$scope.getUserInstrumentDetailsList = function() {
			$scope.instrumentRatingList = "userInstrumentPortfolioDetails";
			if (sectionaccess['Portfolio View.User Updated Details'] != 'Y') {
				$scope.erroruserUpdatedDetailsIns = false;
				$scope.errorMsguserUpdatedDetailsIns = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";

			} else {
				$scope.uniqueCompanyNameIns = [];

				$scope.finalInstrumentDetailsList = $scope.instrumentDetailsList;

				// $scope.instrumentUserModel=true;
				// $scope.instrumentStModel=false;
				$scope.addPrevRatingColumn = false;
				$scope.addFinancialColumn = false;

				$scope.instrumentDetailsGridData = {
					dataProvider : $scope.finalInstrumentDetailsList,
					delegate : $scope
				}
				$.each($scope.finalInstrumentDetailsList,
						function(i, el) {
							if ($.inArray(el.companyCode,
									$scope.uniqueCompanyNameIns) === -1)
								$scope.uniqueCompanyNameIns
										.push(el.companyCode);
						});
				$scope.portfolioRatingDetailsInsCompanyCount = $scope.uniqueCompanyNameIns.length;
				$timeout(function() {
					$scope.instrumentDetailsGridDataInit();
				}, 100);
			}
		}

		$scope.portfoloioListGridCompletion = function(event) {
			portfoloioListGrid = event.target;
			$scope.portfoloioListGridDataInit();
		};
		// For Instrument Details

		$scope.getInstrumentDetails = function() {
			$scope.uniqueCompanyNameIns = [];
			$scope.finalInstrumentDetailsList = $scope.instrumentDetailsList;

			$scope.instrumentRatingList = 'stdinstrumentPortfolioDetails';
			$scope.instrumentDetailsGridData = {
				dataProvider : $scope.finalInstrumentDetailsList,
				delegate : $scope
			}
			$.each($scope.finalInstrumentDetailsList,
					function(i, el) {
						if ($.inArray(el.companyCode,
								$scope.uniqueCompanyNameIns) === -1)
							$scope.uniqueCompanyNameIns.push(el.companyCode);
					});
			$scope.portfolioRatingDetailsInsCompanyCount = $scope.uniqueCompanyNameIns.length;
			$timeout(function() {
				$scope.instrumentDetailsGridDataInit();
			}, 100);
		}

		$scope.instrumentDetailsGridCompletion = function(event) {
			instrumentDetailsGrid = event.target;
			// instrumentDetailsGrid.validateNow();
			$scope.instrumentDetailsGridDataInit();
		};

		// RRDOC for Constituent Details
		$scope.getRRHrefData = function(item, column) {

			if (JSON.stringify(item).includes('CRISIL')) {
				return ('<div><a onClick=openConstituentRRANDCRRDOC(this,"RRDOC") id="'
						+ item.rrDoc
						+ '" name='
						+ '  "'
						+ item.nameOfCompany
						+ '"' + '>' + item.lastRatingAction + '</a></div>');
			}
			return ('<div><span id=' + item.rrDoc + '>' + item.lastRatingAction + '</span></div>');
		}
		// CRR DOC for Constituent Details
		$scope.getCRRHrefData = function(item, column) {
			if (JSON.stringify(item).includes('CRISIL')) {
				return ('<div><a onClick=openConstituentRRANDCRRDOC(this,"CRRDOC") id="'
						+ item.crrDoc
						+ '" name='
						+ '  "'
						+ item.nameOfCompany
						+ '"' + '>' + item.creditRatingReport + '</a></div>');
			}
			return ('<div><span id=' + item.crrDoc + '>'
					+ item.creditRatingReport + '</span></div>');
		}

		// Href for RR and CRR in Constituent Details
		$window.openConstituentRRANDCRRDOC = function(item, itemType) {

			$scope.redirectToRRandCRRDOCConstituentDetails(item, itemType)
		}
		// Reading RRDOC and CRRDOC form companyProfile for Constituent Details
		$scope.redirectToRRandCRRDOCConstituentDetails = function(item,
				itemType) {

			var CRRDOCFile = item.id;
			var type = '';
			var companyNameForRatingDetails = item.name;
			$scope.fileNameForDownload = CRRDOCFile;
			$scope.reportTypeForDownload = itemType;
			var fd = new FormData();
			fd.append('fileName', CRRDOCFile);
			fd.append('docType', itemType);
			fd.append('userDoc', '');
			fd.append('companyName', companyNameForRatingDetails);
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = CRRDOCFile.substring(CRRDOCFile.lastIndexOf(".") + 1);

			if (filext == 'pdf' && filext != '') {
				jQuery('#documentPopUpCons').show();
				jQuery('#documentPopUpFormCons').show();
				jQuery('#documentPopUpConsHTMLPath').hide()
				jQuery('#fileNameHiddenRRCrrCons').val(CRRDOCFile);
				jQuery('#documentTypeHiddenCons').val(itemType);
				jQuery('#companyNameTypeHiddenCons').val(
						companyNameForRatingDetails);
				jQuery('#userDocCons').val($scope.userId);
				jQuery('#documentPopUpFormCons').submit();
				jQuery('#documentPopUpCons').modal({
					show : 'false'
				});

			} else {
				$http.post(uploadUrl, fd, {
					transformRequest : angular.identity,
					// responseType : 'arraybuffer',
					headers : {
						'Content-Type' : undefined,
					}
				}).success(
						function(response) {
							if (response == '') {

								jQuery('#documentPopUpCons').hide();
								jQuery('#documentPopUpFormCons').hide();
								jQuery('#documentPopUpConsHTMLPath').show();
								jQuery('#documentPopUpConsHTMLPath').contents()
										.find('body').html(
												"<p>File Not Found</p>");
								jQuery('#documentPopUpCons').modal({
									show : 'false'
								});
							} else {

								jQuery('#documentPopUpCons').hide();
								jQuery('#documentPopUpFormCons').hide();
								jQuery('#documentPopUpConsHTMLPath').show()
								jQuery('#documentPopUpConsHTMLPath').contents()
										.find('body').html(response);
								jQuery('#documentPopUpCons').modal({
									show : 'false'
								});
							}
						}).error(function(response, status, headers, config) {

				});
			}

		}

		var instrumentData = '';

		$scope.getInstrumentDetailsFilterData = function() {
			$scope.selectedScalesShortTermTemp = [];
			$scope.selectedActionsTemp = [];
			var ratingType = [];
			$scope.ratingTypeValue = [];
			if (vm.selectedScalesShortTerm1 != undefined
					&& vm.selectedScalesShortTerm1.length > 0) {
				$scope.selectedScalesShortTermTemp = vm.selectedScalesShortTerm1
						.map(function(element) {
							if (ratingType.filter(function(x) {
								return x === element.type;
							}).length == 0) {
								ratingType.push(element.type);
							}
							return "<" + String(element.name) + "<"
						})

				$scope.ratingTypeValue = ratingType.map(function(element) {
					return "<" + String(element) + "<";
				})

			}

			if (vm.selectedActions1 != undefined
					&& vm.selectedActions1.length > 0) {
				$scope.selectedActionsTemp = vm.selectedActions1.map(function(
						element) {
					return "<" + String(element.name) + "<"
				})
			}

			if (vm.searchCompanies1 == undefined)
				vm.searchCompanies1 = ' ';

			if (vm.outlook1 == undefined)
				vm.outlook1 = '';

			$scope.flagForRatingDetailsInstru = '';
			if ($scope.instrumentStModel == 'suspendedGr15Ins') {
				$scope.flagForRatingDetailsInstru = $scope.instrumentStModel;
				$scope.instrumentRatingList = 'stdinstrumentPortfolioDetails';
			} else if ($scope.instrumentStModel == 'userInstrumentPortfolioDetails') {
				$scope.instrumentRatingList = 'userInstrumentPortfolioDetails';
			} else if ($scope.instrumentStModel == 'stdinstrumentPortfolioDetails') {
				$scope.instrumentRatingList = 'stdinstrumentPortfolioDetails'
			}

			instrumentData = "{'ratingAction' : '" + $scope.selectedActionsTemp
					+ "', 'ratingType' : '" + $scope.ratingTypeValue
					+ "', 'outStandingRating' : '"
					+ $scope.selectedScalesShortTermTemp
					+ "', 'nameOfCompany' : '" + vm.searchCompanies1
					+ "', 'outlook' : '" + vm.outlook1 + "','condition' : '"
					+ $scope.instrumentStModel + "','agency' : '"
					+ vm.selectedAgenciesForIns + "', 'portfolioId' : '"
					+ $scope.portfolioId + "','asOnDate':'" + vm.singleDate
					+ "','flagForRatD' : '" + $scope.flagForRatingDetailsInstru

					+ "'}";
			instrumentData = instrumentData.replace(/\'/g, "\"");
			instrumentData = instrumentData.replace(/\</g, "\'");
			$scope.inputDataInstruTemp = instrumentData;
			PortfolioService
					.getInstrumentDetails(instrumentData)
					.then(
							function(result) {
								$scope.instrumentDetailsList = result.finalInstrumentList[1];
								$scope.portfolioRatingDetailsInsCompanyCount = result.finalInstrumentList[2];
								$scope.totalcountForInstru = result.finalInstrumentList[3];
								$scope.instrumentDetailsGridData = {
									dataProvider : $scope.instrumentDetailsList,
									delegate : $scope
								}

								$scope.ratingingInstrumentDetailsFilter = instrumentData;
								$timeout(function() {
									$scope.instrumentDetailsGridDataInit();
								}, 100);

							}, function(error) {

							});

		}
		// $scope.instrumentStModel=true;
		$scope.resetInstrumentsFlt = function() {
			$scope.addPrevRatingColumn = false;
			$scope.addFinancialColumn = false;
			vm.selectedActions = [];
			vm.selectedActions1 = [];
			vm.selectedScalesShortTerm1 = [];
			vm.selectedAgenciesForIns = [];
			// $scope.ratingActionData = [];
			$scope.selectedActionsTemp = [];
			vm.searchCompanies1 = ' ';
			vm.outlook1 = '';
			$scope.ratingingInstrumentDetailsFilter = '{"agency": "", "ratingAction": "", "outStandingRating": "", "nameOfCompany": "", "outlook": "" }';
			$scope.getRatingScales();
			$scope.getInstrumentDetailsFilterData();
		}

		/*
		 * if ($stateParams.portfolioId != null ||
		 * angular.isDefined($stateParams.portfolioId)) {
		 * $scope.getPortfolioListFilterData(); }
		 */

		if ($scope.currentbstId == 1) {
			$scope.getPortfolioListFilterData();

		} else {
			$scope.getInstrumentDetailsFilterData();

		}

		// RRDOC for Instrument Details
		$scope.getInstrumentHrefDataRR = function(item, column) {
			// alert(item.RRDocFile);

			if (JSON.stringify(item).includes('CRISIL')) {

				return ('<div><a onClick=openInstrumentRRANDCRRDOC(this,"RRDOC") id='
						+ item.rrdocFile
						+ ' name='
						+ '  "'
						+ item.nameOfCompany
						+ '"'
						+ '>'
						+ item.lastRatingAction + '</a></div>');
			}

			return ('<div><span  id=' + item.rrdocFile + ' name=' + '  "'
					+ item.nameOfCompany + '"' + '>' + item.lastRatingAction + '</span></div>');

		}
		// CRR DOC for Instrument Details
		$scope.getInstrumentHrefCRRData = function(item, column) {

			if (JSON.stringify(item).includes('CRISIL')) {

				return ('<div><a onClick=openInstrumentRRANDCRRDOC(this,"CRRDOC") id='
						+ item.crrdocfile
						+ ' name='
						+ '  "'
						+ item.nameOfCompany
						+ '"'
						+ '>'
						+ item.creditRatingReport + '</a></div>');
			}

			return ('<div><span onClick=openInstrumentRRANDCRRDOC(this,"CRRDOC") id='
					+ item.crrdocfile
					+ ' name='
					+ '  "'
					+ item.nameOfCompany
					+ '"' + '>' + item.creditRatingReport + '</span></div>');

		}

		$window.openInstrumentRRANDCRRDOC = function(item, itemType) {

			$scope.redirectToRRandCRRDOCDetails(item, itemType);
		}

		// Reading RRDOC and CRRDOC form companyProfile for Instrument Details
		$scope.redirectToRRandCRRDOCDetails = function(item, itemType) {
			var CRRDOCFile = item.id;
			var type = '';
			var companyNameForInstruments = item.name;
			$scope.fileNameForDownload = CRRDOCFile;
			$scope.reportTypeForDownload = itemType;
			var fd = new FormData();
			fd.append('fileName', CRRDOCFile);
			fd.append('docType', itemType);
			fd.append('companyName', companyNameForInstruments);
			fd.append('userDoc', '');
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = CRRDOCFile.substring(CRRDOCFile.lastIndexOf(".") + 1);

			if (filext == 'pdf' && filext != '') {
				jQuery('#documentPopUp').show();
				jQuery('#documentPopUpForm').show();
				jQuery('#documentPopUpHTMLPath').hide()
				jQuery('#fileNameHiddenRRCrr').val(CRRDOCFile);
				jQuery('#documentTypeHidden').val(itemType);
				jQuery('#companyNameTypeHidden').val(companyNameForInstruments);
				jQuery('#userDoc').val($scope.userId);
				jQuery('#documentPopUpForm').submit();
				jQuery('#documentPopUp').modal({
					show : 'false'
				});

			} else {

				$http.post(uploadUrl, fd, {
					transformRequest : angular.identity,
					// responseType : 'arraybuffer',
					headers : {
						'Content-Type' : undefined,
					}
				}).success(
						function(response) {

							if (response == '') {

								jQuery('#documentPopUp').hide();
								jQuery('#documentPopUpForm').hide();
								jQuery('#documentPopUpHTMLPath').show();
								jQuery('#documentPopUpHTMLPath').contents()
										.find('body').html(
												"<p>File Not Found</p>");
								jQuery('#documentPopUp').modal({
									show : 'false'
								});
							} else {

								jQuery('#documentPopUp').hide();
								jQuery('#documentPopUpForm').hide();
								jQuery('#documentPopUpHTMLPath').show()
								jQuery('#documentPopUpHTMLPath').contents()
										.find('body').html(response);
								jQuery('#documentPopUp').modal({
									show : 'false'
								});
							}

						}).error(function(response, status, headers, config) {

				});
			}
		}
		$('.toptabsec ul li a').click(function() {
			$('.toptabsec ul li a').removeClass("active");
			$(this).addClass("active");
		});

		$scope.addFinancialColumn = false;
		$scope.addFinancials = function() {
			$scope.removeAlert = true;
			$scope.addFinancialColumn = true;
			$scope.showFinanceBtn = !$scope.showFinanceBtn;
			$scope.portfoloioListGridDataInit();
		}

		$scope.addPrevRatingColumn = false;
		$scope.addPreviousRatings = function() {
			$scope.removeAlert = true;
			$scope.addPrevRatingColumn = true;
			$scope.showRatingBtn = !$scope.showRatingBtn;
			$scope.portfoloioListGridDataInit();
		}

		$scope.portfsetOrRemoveCompanyAlertFlagRL = function(setAlert) {
			var html = '';
			if (setAlert == 0) {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagRL(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagRL(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.setOrRemoveCompanyAlertFlagRL = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}
		// For instrumental list
		$scope.portfsetOrRemoveCompanyAlertFlagIL = function(row, column) {
			var html = '';
			if (row.setAlert == 0) {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagIL(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagIL(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.setOrRemoveCompanyAlertFlagIL = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}

		$scope.setOrRemoveCompanyAlert = function(companyData) {

			var companyDataDto = {
				companyCode : companyData.companyCode,
				industryId : '',
				portFolioId : '',
				isIndustryLevel : 'N',
				isPortfolioLevel : 'N',
				isCompanyLevel : 'Y'

			};

			if (companyData.setAlert == 0) {
				$scope.setStatus = false;
				$uibModal
						.open({

							templateUrl : 'app/alert components/set alert/companyLevelAlert.html',
							controller : 'CompanyLevelAlert',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								companyData : function() {
									return companyDataDto;
								},
								controllerModule : function() {
									return 'RatingDetailsController1';
								},
								parentAccess : function() {
									return $scope;
								},
								isSelectAll : function() {
									return false;
								},
								isInstrumentalFilter : function() {
									return 'N'
								},
								portfolioFilter : function() {
									return ''
								}

							}
						}).closed.then(function() {
					if ($scope.setStatus) {
						companyData.setAlert = 1;

						if ($scope.currentbstId == 1) {
							$scope.getPortfolioListFilterData();
						} else if ($scope.currentbstId == 2) {
							$scope.getInstrumentDetailsFilterData();
						}

						$scope.setStatus = false;

					}
				});

			} else {
				$scope.removeStatus = false;
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlert-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return companyData.nameOfCompany;
								},
								companyData : function() {
									return companyDataDto;
								},
								selectedForAll : function() {
									return 'NA';
								},

								selectedForAlertList : function() {
									return [];
								},
								searchedText : function() {
									return 'NA';
								},
								controllerModule : function() {
									return 'RatingDetailsController1';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {
					if ($scope.removeStatus) {
						companyData.setAlert = 0;
						if ($scope.currentbstId == 1) {
							$scope.getPortfolioListFilterData();
						} else if ($scope.currentbstId == 2) {
							$scope.getInstrumentDetailsFilterData();
						}
						$scope.removeStatus = false;
					}

				});

			}

		}
		$scope.getUserPortfolioForSetAlertAllList = function(inputs) {
			$scope.ratingList = "userPortfolioDetails";
			PortfolioService
					.getUserPortfolioList(inputs)
					.then(
							function(result) {
								$scope.portfolioRatingDetailsList = result.finalConstituentsList[1];
								// alert("data
								// "+$scope.portfolioRatingDetailsList);
								$scope.portfoloioListGridData = {
									dataProvider : $scope.portfolioRatingDetailsList,
									delegate : $scope
								}
							}, function(error) {

							});
		}

		$scope.setAlertForAll = function(filterType) {
			var filter = '';
			var ratingType = $scope.ratingList;
			if (filterType == 'N') {
				filter = $scope.ratingingConstituentsDeatilsFilter;
			} else if (filterType == 'Y') {
				filter = $scope.ratingingInstrumentDetailsFilter;
				ratingType = "instrumentalType";
			}

			var companyDataDto = {
				companyCode : '',
				industryId : '',
				portFolioId : '',
				isIndustryLevel : 'N',
				isPortfolioLevel : 'Y',
				isCompanyLevel : 'N',
				isInstrumentalType : filterType,
				portfolioFilter : filter,
				ratingDetailType : ratingType

			};
			$uibModal
					.open({

						templateUrl : 'app/alert components/set alert/companyLevelAlert.html',
						controller : 'CompanyLevelAlert',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							companyData : function() {
								return companyDataDto;
							},
							controllerModule : function() {
								return 'RatingDetailsController1';
							},
							parentAccess : function() {
								return $scope;
							},
							isSelectAll : function() {
								return true;
							}

						}
					}).closed.then(function() {
			});

		}

		/* Code for dynamic column creation */

		$scope.ratingDetailsStandardDefaultHeaders = {
			'nameOfCompany' : 'Name of Company',
			'industry' : 'Industry',
			'location' : 'Location',
			'listingStatus' : 'Listing Status',
			'ratingAgency' : 'Rating Agency',
			'ratingType' : 'Rating Type',
			'outStandingRating' : 'Outstanding Rating',
			'bankloanratingNew' : 'Bank Loan Rating',
			'capitalmarketInstRating' : 'Capital Market Instrument Rating',
			'outlook' : 'Outlook',
			'amountRated' : 'Amount Rated (Rs. Cr)',
			'blrAmount' : 'BLR Amount (Rs. Cr)',
			'capitalmarketInstAmt' : 'Capital Market Instrument Rated Amount (Rs. Cr)',
			'ratingAction' : 'Rating Action',
			'ratingWatch' : 'Rating Watch',
			'lastRatingAction' : 'Last Rating Action Date',
			'creditRatingReport' : 'Credit Rating Report',
			'setAlert' : 'Set Alert',
		};

		$scope.ratingDetailsUserUpdatedDefaultHeaders = {
			'nameOfCompany' : 'Name of Company',
			'industry' : 'Industry',
			'location' : 'Location',
			'ratingAgency' : 'Rating Agency',
			'ratingType' : 'Rating Type',
			'outStandingRating' : 'Outstanding Rating',
			'bankloanratingNew' : 'Bank Loan Rating',
			'capitalmarketInstRating' : 'Capital Market Instrument Rating',
			'outlook' : 'Outlook',
			'amountRated' : 'Amount Rated (Rs. Cr)',
			'blrAmount' : 'BLR Amount (Rs. Cr)',
			'capitalmarketInstAmt' : 'Capital Market Instrument Rated Amount (Rs. Cr)',
			'ratingAction' : 'Rating Action',
			'ratingWatch' : 'Rating Watch',
			'lastRatingAction' : 'Last Rating Action (Date)',
			'creditRatingReport' : 'Credit Rating Report',
			'client_unique_code' : 'Client Unique Code',
			'constitution_of_entities' : 'Constitution of Entities',
			'industryClass' : 'Industry Classification',
			'branch_location' : 'Branch Location',
			'internal_rating' : 'Internal Rating',
			'rate_of_interest' : 'ROI',
			'exposure_total' : 'Exposure total',
			'exposure_fund_based' : 'Exposure – fund Based',
			'exposure_nonfund_based' : 'Exposure Non fund based',
			'setAlert' : 'Set Alert',
		};

		$scope.ratingDetailsFinancialHeaders = {
			// Add Financial columns
			'resulttype' : 'Result Type',
			'yearended' : 'Year',
			'operatingIncome' : 'Operating Income',
			'netWorth' : 'Net Worth',
			'totalDebt' : 'Total Debt',
			'ebitda' : 'EBITDA',
			'pat' : 'PAT',
			'netCashAccruals' : 'Net Cash Accruals',
			'equityShareCapital' : 'Equity Share Capital',
			'operatingProfitMargin' : 'Operating Profit Margin',
			'netProfitMargins' : 'Net Profit Margin',
			'roce' : 'RoCE',
			'debtToEquity' : 'Debt to Equity',
			'interestCoverage' : 'Interest Coverage',
			'ncaToTotalDebt' : 'NCA to Total debt',
			'currentRatio' : 'Current Ratio',
			'revenueGrowth' : 'Revenue Growth (%)',
			'netProfitGrowth' : 'Netprofit Growth (%)',

		}

		$scope.ratingDetailsPrevRatingHeaders = {
			// Previous Rating columns
			'preRating' : 'Previous Rating',
			'preRatingOut' : 'Previous Rating Outlook',
			'preRatingAct' : 'Previous Rating Action',
			'prePrDATE' : 'Previous PR Date'
		}

		$scope.instrumentDetailsStandardDefaultHeaders = {
			'nameOfCompany' : 'Company Name',
			'industry' : 'Industry',
			'location' : 'Location',
			'listingStatus' : 'Listing Status',
			'ratingAgency' : 'Rating Agency',
			'ratingType' : 'Rating Type',
			'instrumentName' : 'Instrument Name',
			'lastRatingAction' : 'Last Rating Action (Date)',
			'creditRatingReport' : 'Credit Rating Report',
			'outStandingRating' : 'Outstanding Rating',
			'bankLoanRating' : 'Bank Loan Rating',
			'capitalmarketInstRating' : 'Capital Market Instrument Rating',
			'outlook' : 'Outlook',
			'amountRated' : 'Amount Rated (Rs. Cr)',
			'blrAmount' : 'BLR Amount (Rs. Cr)',
			'capitalmarketInstAmt' : 'Capital Market Instrument Rated Amount (Rs. Cr)',
			'ratingAction' : 'Rating Action',
			'ratingWatch' : 'Rating Watch',
			'setAlert' : 'Set Alert',
		};

		$scope.instrumentDetailsUserUpdatedDefaultHeaders = {
			'nameOfCompany' : 'Name of Company',
			'industry' : 'Industry',
			'location' : 'Location',
			'ratingAgency' : 'Rating Agency',
			'ratingType' : 'Rating Type',
			'lastRatingAction' : 'Last Rating Action (Date)',
			'creditRatingReport' : 'Credit Rating Report',
			'instrumentName' : 'Instrument Name',
			'outStandingRating' : 'Outstanding Rating',
			'bankLoanRating' : 'Bank Loan Rating',
			'capitalmarketInstRating' : 'Capital Market Instrument Rating',
			'outlook' : 'Outlook',
			'amountRated' : 'Amount Rated (Rs. Cr)',
			'blrAmount' : 'BLR Amount (Rs. Cr)',
			'capitalmarketInstAmt' : 'Capital Market Instrument Rated Amount (Rs. Cr)',
			'ratingAction' : 'Rating Action',
			'ratingWatch' : 'Rating Watch',
			'constitutionOfEntity' : 'Constitution of Entities',
			'userIndustryName' : 'Industry Classification',
			'branchLocation' : 'Branch Location',
			'internalRating' : 'Internal Rating',
			'rateOfInterest' : 'ROI (%)',
			'exposureTotal' : 'Exposure total',
			'exposerFundBased' : 'Exposure – fund Based',
			'exposernonFundBased' : 'Exposure Non fund based',
			'setAlert' : 'Set Alert',
		};

		$scope.isAddFinancialsActive = false;
		$scope.isAddPrvRatingActive = false;

		$scope.portfoloioListGridDataInit = function() {

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];
			$scope.tempRatingColums = [];
			$scope.tempFinancialColumns = [];
			var setAlert = null;

			$scope.defaultColumns = {};
			if ($scope.ratingList == 'userPortfolioDetails') {
				$scope.defaultColumns = $scope.ratingDetailsUserUpdatedDefaultHeaders;
			} else {
				$scope.defaultColumns = $scope.ratingDetailsStandardDefaultHeaders;
			}

			// for main columns
			angular
					.forEach(
							$scope.defaultColumns,
							function(value, key) {
								var mCol = new flexiciousNmsp.FlexDataGridColumn();
								var headerText = value;
								var dataField = key;
								mCol.setHeaderText(headerText);
								mCol.setDataField(dataField);
								if (dataField == 'setAlert') {
									mCol
											.setLabelFunction($scope.portfsetOrRemoveCompanyAlertFlagIL);
								}
								if (dataField == 'amountRated'
										|| dataField == 'blrAmount'
										|| dataField == 'capitalmarketInstAmt'
										|| dataField == 'rate_of_interest'
										|| dataField == 'exposureTotal'
										|| dataField == 'exposerFundBased'
										|| dataField == 'exposernonFundBased'
										|| dataField == 'lastRatingAction'
										|| dataField == 'creditRatingReport'
										|| dataField == 'prePrDATE'		
								) {
									mCol.setStyle("textAlign", "right");
								}
								if (dataField == 'lastRatingAction') {
									mCol.setLabelFunction($scope.getRRHrefData);
								}
								if (dataField == 'creditRatingReport') {
									mCol
											.setLabelFunction($scope.getCRRHrefData);
								}

								mCol.headerAlign = "center";
								mCol.setColumnWidthMode("fixed");
								mCol.setWidth(100);
								mCol.sortable = false;
								mCol.enableCellClickRowSelect = false;
								allheadCols.push(mCol);
							});

			// for financial column
			angular.forEach($scope.ratingDetailsFinancialHeaders, function(
					value, key) {
				var mCol = new flexiciousNmsp.FlexDataGridColumn();
				var headerText = value;
				var dataField = key;
				mCol.setHeaderText(headerText);
				mCol.setDataField(dataField);
				mCol.headerAlign = "center";
				mCol.setColumnWidthMode("fixed");
				mCol.setWidth(100);
				mCol.sortable = false;
				mCol.enableCellClickRowSelect = false;
				$scope.tempFinancialColumns.push(mCol);
			});

			// for prv rating column
			angular.forEach($scope.ratingDetailsPrevRatingHeaders, function(
					value, key) {
				var mCol = new flexiciousNmsp.FlexDataGridColumn();
				var headerText = value;
				var dataField = key;
				mCol.setHeaderText(headerText);
				mCol.setDataField(dataField);
				mCol.headerAlign = "center";
				mCol.setColumnWidthMode("fixed");
				mCol.setWidth(100);
				mCol.sortable = false;
				mCol.enableCellClickRowSelect = false;
				$scope.tempRatingColums.push(mCol);
			});

			// for replacing setAlert to last
			setAlert = allheadCols.pop();

			// for financial button
			if ($scope.addFinancialColumn) {
				$scope.isAddFinancialsActive = !$scope.isAddFinancialsActive;

				if ($scope.isAddFinancialsActive == true) {

					angular.forEach($scope.tempFinancialColumns, function(
							value, key) {
						allheadCols.push(value);
					});

					if ($scope.isAddPrvRatingActive == true) {
						angular.forEach($scope.tempRatingColums, function(
								value, key) {
							allheadCols.push(value);
						});
					}
				} else if ($scope.isAddFinancialsActive == false) {
					if ($scope.isAddPrvRatingActive == true) {
						angular.forEach($scope.tempRatingColums, function(
								value, key) {
							allheadCols.push(value);
						});
					}
				}
				$scope.addFinancialColumn = false;
			}

			// for rating button
			if ($scope.addPrevRatingColumn) {
				$scope.isAddPrvRatingActive = !$scope.isAddPrvRatingActive;

				if ($scope.isAddPrvRatingActive == true) {
					angular.forEach($scope.tempRatingColums, function(value,
							key) {
						allheadCols.push(value);
					});

					if ($scope.isAddFinancialsActive == true) {
						angular.forEach($scope.tempFinancialColumns, function(
								value, key) {
							allheadCols.push(value);
						});

					}
				} else if ($scope.isAddPrvRatingActive == false) {
					if ($scope.isAddFinancialsActive == true) {
						angular.forEach($scope.tempFinancialColumns, function(
								value, key) {
							allheadCols.push(value);
						});
					}
				}
				$scope.addPrevRatingColumn = false;
			}

			allheadCols.push(setAlert);
			ycgmain.setColumns(allheadCols);
			portfoloioListGrid.getColumnLevel().setGroupedColumns(gridCgs);
			portfoloioListGrid.setPreservePager(true);
			portfoloioListGrid.setTotalRecords($scope.totalcount);
			portfoloioListGrid.rebuild();
			portfoloioListGrid.validateNow();
		}

		$scope.instrumentDetailsGridDataInit = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];

			$scope.defaultColumns = {};
			if ($scope.instrumentRatingList == 'stdinstrumentPortfolioDetails') {
				$scope.defaultColumns = $scope.instrumentDetailsStandardDefaultHeaders;
			} else {
				$scope.defaultColumns = $scope.instrumentDetailsUserUpdatedDefaultHeaders;
			}

			angular
					.forEach(
							$scope.defaultColumns,
							function(value, key) {
								var mCol = new flexiciousNmsp.FlexDataGridColumn();
								var headerText = value;
								var dataField = key;
								mCol.setHeaderText(headerText);

								mCol.setDataField(dataField);
								if (dataField == 'setAlert') {
									mCol
											.setLabelFunction($scope.portfsetOrRemoveCompanyAlertFlagIL);
								}
								if (dataField == 'amountRated'
										|| dataField == 'blrAmount'
										|| dataField == 'capitalmarketInstAmt'
										|| dataField == 'rateOfInterest'
										|| dataField == 'exposureTotal'
										|| dataField == 'exposerFundBased'
										|| dataField == 'exposernonFundBased'
										|| dataField == 'lastRatingAction'
										|| dataField == 'creditRatingReport'
										|| dataField == 'prePrDATE'	
								) {
									mCol.setStyle("textAlign", "right");
								}
								if (dataField == 'lastRatingAction') {
									mCol
											.setLabelFunction($scope.getInstrumentHrefDataRR);
								}
								if (dataField == 'creditRatingReport') {
									mCol
											.setLabelFunction($scope.getInstrumentHrefCRRData);
								}

								mCol.headerAlign = "center";
								mCol.setColumnWidthMode("fixed");
								mCol.setWidth(100);
								mCol.sortable = false;
								mCol.enableCellClickRowSelect = false;
								allheadCols.push(mCol);
							});

			ycgmain.setColumns(allheadCols);
			instrumentDetailsGrid.getColumnLevel().setGroupedColumns(gridCgs);
			instrumentDetailsGrid.rebuild();
			instrumentDetailsGrid.setTotalRecords($scope.totalcountForInstru);
			instrumentDetailsGrid.validateNow();
		}

		$scope.downloadRRCRRReport = function() {
			var fileNames = $scope.fileNameForDownload;
			var documentTypess = $scope.reportTypeForDownload;
			var fd = new FormData();
			fd.append('fileName', fileNames);
			fd.append('docType', documentTypess);

			var uploadUrl = 'api/RRCRR/downloadPdf';
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				responseType : 'arraybuffer',
				headers : {
					'Content-Type' : undefined,
				}
			}).success(
					function(response) {

						var isIE = false || !!document.documentMode;
						$scope.response = response;
						var blob = new Blob([ response ], {
							type : 'application/octet-stream'
						});
						if (isIE) {

							window.navigator.msSaveOrOpenBlob(blob,
									$scope.fileNameForDownload);
						} else {

							var anchor = angular.element('<a/>');
							var blob = new Blob([ response ], {
								type : 'application/octet-stream'
							})
							var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
							anchor.css({
								display : 'none'
							});
							// Make sure it's not visible
							angular.element(document.body).append(anchor); // Attach
							// to
							// document
							anchor.attr({
								href : objectUrl,
								target : '_self',

								download : $scope.fileNameForDownload
							})[0].click();

							anchor.remove();

						}
						$scope.updateStatusForRRCRRReport(fileNames,
								documentTypess);

					})

		}

		$scope.updateStatusForRRCRRReport = function(fileNames, documentTypess) {

			var fd = new FormData();
			fd.append('fileName', fileNames);
			fd.append('docType', documentTypess);

			GenericService.updateDownloadStatusForRRCRRreport(fd);
		}

		// server side pegination
		var portfoloioListGridData = '';
		var portfoloioListDFilter = {};
		$scope.filterPageSortChangeHandlerRatingDetails = function(evt1) {

			portfoloioListGridData = evt1.target;
			portfoloioListDFilter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.inputDataTemp,
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};

			baseRequest(
					'api/portfolio/getFilterServerSidePaginationForRatingDetail',
					portfoloioListDFilter)
					.then(
							function(response) {
								portfoloioListGridData.setPreservePager(true);
								portfoloioListGridData
										.setDataProvider(response.data.typeOfRatingList);
								$scope.ratedPaginationList = response.data.typeOfRatingList;
								if ($scope.ratedPaginationList.length > 0) {
									$scope.ratingDetailsTotalPaginationCounts = response.data.totalCountOfList;
									portfoloioListGridData
											.setTotalRecords($scope.ratingDetailsTotalPaginationCounts);
								} else {
									portfoloioListGridData.setTotalRecords(0);
								}
								portfoloioListGridData.validateNow();

							});

		}
		// server side pagination for instrument
		var portfoloioListInstruFilter = {};
		var instrumentDetailsGridData = '';
		$scope.filterPageSortChangeHandlerForInstruRatingDetails = function(
				evt1) {

			instrumentDetailsGridData = evt1.target;
			portfoloioListInstruFilter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.inputDataInstruTemp,
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};

			baseRequest(
					'api/portfolio/getFilterServerSidePaginationForRatingDetailInstrument',
					portfoloioListInstruFilter)
					.then(
							function(response) {

								instrumentDetailsGridData
										.setPreservePager(true);
								instrumentDetailsGridData
										.setDataProvider(response.data.typeOfRatingList);
								$scope.instruPaginationList = response.data.typeOfRatingList;
								if ($scope.instruPaginationList.length > 0) {
									$scope.ratingDetailsInstruTotalPaginationCounts = response.data.totalCountOfList;
									instrumentDetailsGridData
											.setTotalRecords($scope.ratingDetailsInstruTotalPaginationCounts);
								} else {
									instrumentDetailsGridData
											.setTotalRecords(0);
								}
								instrumentDetailsGridData.validateNow();

							});

		}
	}
})();
